
import { Component, Prop, Vue } from 'vue-property-decorator'
import { formatDayMonthYearString } from '~/lib/utils/date'
import { formatToUSDCurrency } from '~/lib/utils/format'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'

@Component({
  name: 'SuccessReactivateModal',
  components: {
    CloseCrossCtrl
  }
})
export default class SuccessReactivateModal extends Vue {
  @Prop({ type: String, default: '' }) modalName: string
  @Prop({ type: String, default: '' }) subscriptionName: string
  @Prop({ type: String, default: '' }) packagePrice: string
  @Prop({ type: String, default: '' }) renewalDate: string

  get price():number {
    return Number(this.packagePrice)
  }

  get formatPrice() {
    return formatToUSDCurrency
  }

  get formattedExpirationDate() {
    return formatDayMonthYearString(this.renewalDate, '$day $monthLetterAbbr, $year')
  }
}
